import { useEffect } from "react";

import { useAppSelector } from "../../redux/hooks";

const HELP_SCOUT_BEACON_ID = "ef7a5f7e-bdd9-4e66-bff3-f2b696eb106e";

const HELP_SCOUT_LOADER = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;

export const HelpScoutBeacon = (): null => {
  const user = useAppSelector((state) => state.user);

  useEffect(() => {
    if (typeof window.Beacon !== "function") {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.text = HELP_SCOUT_LOADER;
      document.head.appendChild(script);
    }
    window.Beacon("init", HELP_SCOUT_BEACON_ID);
    window.Beacon("config", { display: { position: "left" } });
  }, []);

  useEffect(() => {
    if (typeof window.Beacon !== "function") return;
    window.Beacon("identify", {
      name: user?.name ?? "",
      email: user?.email ?? "",
    });
  }, [user?.name, user?.email]);

  return null;
};
